import React from 'react';
import { CalendarIcon, FilterIcon, CheckCircle2Icon, ClockIcon, ChevronRightIcon } from 'lucide-react';
const MOCK_HISTORY = [{
  id: 1,
  area: 'Emergencia',
  date: 'Hoy, 10:45 AM',
  total: 45,
  synced: false
}, {
  id: 2,
  area: 'UCI',
  date: 'Hoy, 09:15 AM',
  total: 28,
  synced: false
}, {
  id: 3,
  area: 'Pediatría',
  date: 'Ayer, 04:30 PM',
  total: 32,
  synced: true
}, {
  id: 4,
  area: 'Quirófano',
  date: 'Ayer, 02:15 PM',
  total: 56,
  synced: true
}, {
  id: 5,
  area: 'Maternidad',
  date: 'Ayer, 11:00 AM',
  total: 41,
  synced: true
}];
export function HistoryScreen() {
  return <div className="flex flex-col h-full" data-id="element-127">
      {/* Filters */}
      <div className="bg-white p-4 border-b border-gray-200 sticky top-0 z-10 shadow-sm" data-id="element-128">
        <div className="flex gap-3" data-id="element-129">
          <button className="flex-1 flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700" data-id="element-130">
            <div className="flex items-center gap-2" data-id="element-131">
              <CalendarIcon className="w-4 h-4 text-gray-500" data-id="element-132" />
              <span data-id="element-133">Esta semana</span>
            </div>
          </button>
          <button className="flex items-center justify-center bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700" data-id="element-134">
            <FilterIcon className="w-4 h-4" data-id="element-135" />
          </button>
        </div>
      </div>

      {/* List */}
      <div className="p-4 flex flex-col gap-3" data-id="element-136">
        {MOCK_HISTORY.map(item => <div key={item.id} className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex items-center active:bg-gray-50 transition-colors" data-id="element-137">
            <div className="flex-1" data-id="element-138">
              <div className="flex items-center gap-2 mb-1" data-id="element-139">
                <h3 className="font-bold text-gray-900 text-lg" data-id="element-140">{item.area}</h3>
                {item.synced ? <CheckCircle2Icon className="w-4 h-4 text-green-500" data-id="element-141" /> : <ClockIcon className="w-4 h-4 text-orange-400" data-id="element-142" />}
              </div>
              <p className="text-sm text-gray-500" data-id="element-143">{item.date}</p>
            </div>

            <div className="flex items-center gap-3" data-id="element-144">
              <div className="bg-blue-50 px-3 py-1.5 rounded-lg text-center" data-id="element-145">
                <span className="block text-lg font-bold" style={{
              color: '#134073'
            }} data-id="element-146">
                  {item.total}
                </span>
                <span className="block text-[10px] text-gray-500 uppercase tracking-wider" data-id="element-147">
                  Prendas
                </span>
              </div>
              <ChevronRightIcon className="w-5 h-5 text-gray-300" data-id="element-148" />
            </div>
          </div>)}
      </div>
    </div>;
}